import type { IconData } from '@stacksjs/iconify-core'

export const eraser: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3.815 24.167c-1.096 1.428-1.048 3.242.1 4.63c1.205 1.458 3.205 3.674 6.455 6.826q.29.282.57.551a3 3 0 0 0 2.16.824c2.731-.08 7.3-.16 14.543-.16c.504 0 .99-.185 1.363-.524a177 177 0 0 0 4.243-3.992c5.482-5.317 8.42-8.734 9.958-10.738c1.096-1.427 1.047-3.242-.1-4.63c-1.205-1.458-3.206-3.674-6.455-6.826s-5.534-5.093-7.036-6.26c-1.431-1.114-3.302-1.161-4.774-.098c-2.066 1.491-5.588 4.342-11.07 9.659c-5.481 5.317-8.42 8.734-9.957 10.738M9 43h36\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default eraser
